import { SegmentPartnerRevenueMethod } from '@openx/types/gqlTypes.ts';
import type { PricingConfig } from '../OrganizationPricingItem.tsx';

export const calculateNetFee = (value: string, pricingType: SegmentPartnerRevenueMethod, maxPrice: number): number => {
  const isCpm = pricingType === SegmentPartnerRevenueMethod.Cpm;

  if (!value) {
    return isCpm ? maxPrice : maxPrice * 100;
  }

  const platformFeePercent = Number(value);
  if (!Number.isFinite(platformFeePercent)) {
    return isCpm ? maxPrice : maxPrice * 100;
  }

  if (isCpm) {
    return maxPrice * (1 - platformFeePercent / 100);
  }

  return maxPrice * 100 * (1 - platformFeePercent / 100);
};

export const createPricingConfig = (
  segmentPartnerRevenueMethod: SegmentPartnerRevenueMethod,
  priceCpm: number,
  pricePom: number
): PricingConfig => {
  if (segmentPartnerRevenueMethod === SegmentPartnerRevenueMethod.Cpm) {
    return { type: SegmentPartnerRevenueMethod.Cpm, price: priceCpm };
  }

  return { type: SegmentPartnerRevenueMethod.PoM, price: pricePom };
};
